import type NonNegativeNumber from './non-negative-number';
import { assertIsInstanceOfNonNegativeNumber } from './assertions';

interface IDiscount {
	readonly amount: NonNegativeNumber;
	readonly percent: NonNegativeNumber;
}

export default class Discount implements IDiscount {
	public get amount(): NonNegativeNumber {
		return this.#amount;
	}

	public get percent(): NonNegativeNumber {
		return this.#percent;
	}

	#amount: NonNegativeNumber;
	#percent: NonNegativeNumber;

	public constructor({ amount, percent }: IDiscount) {
		assertIsInstanceOfNonNegativeNumber(amount);
		this.#amount = amount;
		assertIsInstanceOfNonNegativeNumber(percent);
		this.#percent = percent;
	}
}
